var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',[_c('div',{staticClass:"boxClass"},[_c('span',[_vm._v("配置项统计")]),_c('div',[_c('router-link',{attrs:{"to":{ path: '/configChangeStatis'}}},[_c('span',[_vm._v("配置项变更统计")])])],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }